"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _getWindow = _interopRequireDefault(require("../utils/get-window"));

var _shallowEqualObjects = _interopRequireDefault(require("../utils/shallow-equal-objects"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Display an Assembly icon.
 *
 * Besides providing a convenient shortcut, this component does the following:
 *
 * - Sets some accessibility props.
 * - Provides an `inline` mode that automatically sizes icons to match their
 *   surrounding text.
 */
class Icon extends _react.default.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "setIconElement", element => {
      this.iconElement = element;
    });
  }

  componentDidMount() {
    this.setHeight();
  }

  shouldComponentUpdate(nextProps) {
    return !(0, _shallowEqualObjects.default)(this.props, nextProps, ['passthroughProps']);
  }

  componentDidUpdate() {
    this.setHeight();
  }

  setHeight() {
    if (this.props.inline && this.iconElement) {
      const lineHeight = (0, _getWindow.default)().getComputedStyle(this.iconElement)['line-height'];
      this.iconElement.style.height = lineHeight;
    }
  }

  render() {
    const {
      props
    } = this;
    let iconClasses = 'events-none icon';

    if (props.inline) {
      iconClasses += ' inline-block align-t';
    }

    const svgStyle = props.passthroughProps.style || {};

    if (!svgStyle.width && props.size) {
      svgStyle.width = props.size;
    }

    if (!svgStyle.height && props.size) {
      svgStyle.height = props.size;
    }

    const iconContent = /*#__PURE__*/_react.default.createElement("svg", _extends({
      ref: this.setIconElement,
      role: "presentation",
      focusable: "false",
      className: iconClasses
    }, props.passthroughProps, {
      style: svgStyle
    }), /*#__PURE__*/_react.default.createElement("use", {
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      xlinkHref: `#icon-${props.name}`
    }));

    return iconContent;
  }

}

exports.default = Icon;
Icon.propTypes = {
  /**
   * The name of the [Assembly icon](https://labs.mapbox.com/assembly/icons/) that
   * you want to display.
   */
  name: _propTypes.default.string.isRequired,

  /**
   * The width and height of the icon. All icons fill up a square space,
   * so this value will be applied to both width and height.
   *
   * If `inline: true`, the technical height will be controlled by the
   * line-height of the container, but the appearance of the icon will still
   * be in accordance with your `size` value (because it's limited by the
   * width).
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the icon will be adjusted after mounting so that its height
   * matches the line-height of its container. The result of this is that
   * the icon will not displace the text's established line-height and
   * will be vertically centered with the text alongside it.
   *
   * This is most useful when you are inserting the icon within multiline text,
   * so you can't use a flexbox layout to vertically center the icon and text.
   *
   * Be aware that there are edge cases that can cause problems with this
   * setting. For example, it won't work well if you don't have a `line-height`
   * set to a pixel value, or if there are dynamic adjustments to the
   * line-height.
   */
  inline: _propTypes.default.bool,

  /**
   * Props to pass directly to the `<svg>` element.
   */
  passthroughProps: _propTypes.default.object
};
Icon.defaultProps = {
  inline: false,
  passthroughProps: {},
  size: 18
};